module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('span', {
    attrs: {
      "id": "Page_52",
      "title": "[52]"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "pgepubid00005"
    }
  }, [_vm._v("IV"), _c('br', {
    staticClass: "calibre17"
  }), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("JULIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Overhead")]), _vm._v(" the high thin air swished, beaten by the\nwings of wild ducks that flew swiftly across the sky in\nan even fan-shaped line. Uncle kept looking up at\nthem. Once when he spoke to them in strange muttered\nwords, Big Sue observed:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Lawd, do listen at Uncle! A-talkin’ to dem ducks\nsame as if dey was speerits!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The trees leaned dreamily over the water which\ntrembled as the sun turned it to dark blood. Uncle’s\npulling slackened. The flat touched the firm earth at\nlast.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("With amazing nimbleness the old man hopped out\nand tied it fast to a tree, his crooked fingers fumbling\nstubbornly with the frayed rope until he was satisfied\nit would hold; then he followed Big Sue and Breeze up\na short sandy climb where the road made a swift bend\nand ran underneath great trees whose thick branches\nlapped overhead, shutting out all but small white pieces\nof the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("A bony gray mule hitched to a two-wheeled car stood\ntethered to a limb. Uncle hobbled to the beast’s head:\n“Wake up, Julia! Open you’ eyes, gal! You too love\nto nod! Dat’s de biggest fault I got to find wid you!\nLula was a wakeful mule! Lawd, yes!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Big Sue was panting and climbing in over the cart’s\nwheel, using the hub for a step. She sat on a board laid\nacross the body. Breeze got in and sat on the floor."), _c('span', {
    attrs: {
      "id": "Page_53",
      "title": "[53]"
    }
  }), _vm._v("\nUncle crawled over the dashboard, and jerking the rope\nlines urged Julia to move on.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Mind, Julia! Don’ git me vexed! I ain’ used to\nno triflin’ ways! Lula was pearter’n dis!” Uncle sat\nup very straight and his tone was terribly threatening.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Julia shook the gnats out of her ears, then snorted\nthem out of her nose, but not until Uncle got to his feet\nand, raising a long dry stick high as his arm could reach,\nbrought it down on her hip with a powerful whack did\nshe move out of her tracks.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Git up, Julia!” He gave her another lick, and she\nturned slowly about and got into the sandy road.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Big Sue heaved a weary sigh.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Julia is de laziest mule I ever seen in my life,\nUncle! Whilst you was a-buyin’ one, whyn’t you git a\nspry one?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Julia ain’ lazy. E’s just careful. Julia knows dis\ncart ain’ so strong.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I hear-say Julia kicks awful bad sometimes!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Who? Julia? No, ma’am! Julia’s kind as kin\nbe!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“E looks awful old, Uncle.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Julia ain’ no more’n ten.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“How come e front knees is so bent over if e ain’\nold?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Bent over? Julia’s got to bend e knees to walk,\nenty?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Well do, fo’ Gawd’s sake, lick em an’ make em\nwalk a li’l’ faster. We wouldn’t git home befo’ to-morrow\nif you don’t. Lawd, I’m sorry Lula’s dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Me too, Big Sue. Now Lula was a mule fo’ true.\nLula was de finest mule ever was on Blue Brook. Julia\nain’ got no time wid em. Lula had sense like people. I\nmiss em too bad. I ruther de boll-evils had eat up all\nde cotton on de plantation dan to ’a’ had Lula pizened."), _c('span', {
    attrs: {
      "id": "Page_54",
      "title": "[54]"
    }
  }), _vm._v("\nI told April to don’ fetch dat pizen to de place. I\nknowed somet’ing bad was gwine happen soon as he\ndone it. But April is a headstrong man. Nobody can’\nchange him when he gits his mind made up.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“April tries to be big doins’ like de buckra, enty?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“No, gal, not like de buckra. April’s done passed by\nde buckra! April aims to do like Gawd now!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Shut you’ mouth, Uncle! You’s a case!” Big Sue\nroared with laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“April better quit pizenin’ all dem bugs Gawd put\nin de cotton!” Uncle contended.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Big Sue pondered over this, but presently she\ngrinned and slipped a look at Uncle.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“When Lula died, whyn’t you bought a awtymobile,\nUncle? I hear-say you got plenty o’ money buried all\nround you’ house.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Who? Me? Great Gawd! I ain’ got fi’ cents\nburied! But if I had a t’ousand dollars I wouldn’ buy\na awtymobile! Not me!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“How come so?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Lawd, dey smells too bad! An’ I seen how dey\ntreats de buckra. Dey goes sound to sleep on de road\nany time dey gits ready. Soon’s dey gits in deep sand\nwhe’ de pullin’ is tight, dey squats right down an’ dozes\noff. You can’ lick ’em wid no stick like I licks Julia to\nwake ’em up. No, ma’am. You have to set an’ wait on\n’em till dey nap is out. Dey kin dead easy too. I\nwouldn’ trust to buy one. No, Jedus. Dey breath is\nstink as a pole-cat too.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Lawd, Uncle, you is a case in dis world! A heavy\ncase!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Uncle’s eyes twinkled. “You ax me so much a questions,\nnow le’ me ax you one. How come you’ wind is so\nshort, daughter? You been puffin’ like a steamboat ever\nsince you come up dat li’l’ small hill.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_55",
      "title": "[55]"
    }
  }), _vm._v("Big Sue’s hands caught at each other anxiously. “I\ndunno, Uncle. My wind is short fo’ true. E’s been short\nsince last Sunday was a week. I eat a piece o’ possum\nwhat was kinder spoilt fo’ my supper last night, an’\nI ain’ been hardly able to travel all day. Spoilt victuals\nnever did set right in my stomach, somehow. I don’\nknow how come so.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("As Uncle studied, his eyes snapped. “Sp’ilt possum\nmeat wouldn’ hurt nobody. You looks to me like you’s\nconjured. You’ eyes looks strainin’. You must ’a’\ncrossed somebody dat Sunday.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Big Sue’s fat face looked ready to cry. “I ain’ never\ndone nobody a harm t’ing in my life, Uncle. I stays\nhome all de time. I goes to church on Sunday, den I\ncomes straight back home. I don’ hardly go to meetin’\non Wednesday night. I went all de way to Sandy Island\nto git dis boy, by I was so lonesome yonder home\nby myself. Who you reckon would conjure me, Uncle?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Uncle shook his head gravely. That was hard to tell.\nSome people get mighty mean if you cross them.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I don’ cross nobody, Uncle.” Big Sue was whimpering.\n“Not nobody! I ever was peaceable.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Is you an’ Leah friendly dese days? Leah is a\nmighty jealous ’oman, Big Sue.” Uncle’s eyes sparkled\nas they sought Big Sue’s, but she met them boldly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I ain’ got April to study ’bout, Uncle.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("A smile twitched Uncle’s dry wrinkled face. “How\n’bout de new town preacher, daughter? I hear-say you\nan’ Leah all two is raven ’bout em. Better mind. De\nnext t’ing you know dat same preacher’ll make you have\nsin.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Big Sue laughed with relief. “No, Uncle. You’s\non de wrong trail now. A preacher couldn’t make me\nhave sin, anyhow.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“How come so?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_56",
      "title": "[56]"
    }
  }), _vm._v("“De preacher’s a Christian man, enty? An’ I is a\nChristian, enty? One clean sheet can’ soil another,\nUncle.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Shut you’ fool-mouth, Big Sue. You, neither dat\npreacher, neither Leah, ain’ no cleaner’n nobody else.\nYou kin have sin de same as me. Sho’ you kin!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Uncle brought his stick down with a whack on\nJulia’s back.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15a8528f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0006.vue
// module id = 72
// module chunks = 0